import React from 'react';
import b from 'b_';

import { BreadcrumbsStub } from 'client/components/breadcrumbs';
import Rect from 'client/components/rect';

const class_ = b.with('page');

export default () => {
    return (
        <>
            <BreadcrumbsStub />
            <div className={class_({ type: 'tag' })}>
                <div className={class_('content')}>
                    <h1><Rect type="black" height="30px" width="50%" /></h1>
                    <h3>
                        <div style={{ marginBottom: '10px' }}><Rect height="25px" /></div>
                        <div style={{ marginBottom: '10px' }}><Rect height="25px" /></div>
                        <div style={{ marginBottom: '10px' }}><Rect height="25px" /></div>
                        <div><Rect height="25px" /></div>
                    </h3>
                </div>
            </div>
        </>
    );
};
